import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const MWIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="MW" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#E11C1B"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#272727"
          fillRule="evenodd"
          d="M0 0v4.8h16V0H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#5EAA22"
          fillRule="evenodd"
          d="M0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          fill="#E11C1B"
          d="M2.37 5.024h-.054l-.029-.013.083.013Zm5.923-2.392c.124.005.247.015.368.028l.495-1.313-.054 1.38c.122.025.243.05.362.083l.743-1.204-.327 1.336c.118.043.234.09.347.141l.963-1.054-.582 1.245c.111.062.22.127.324.197l1.14-.87-.808 1.113c.1.08.197.165.289.253l1.271-.663-.998.95c.085.097.166.2.24.304l1.359-.442-1.154.763c.028.048.053.096.079.145h-.98c-.678-.939-1.915-1.568-3.329-1.568-1.414 0-2.65.63-3.328 1.568H3.78l.081-.15-1.145-.758 1.35.439a4.1 4.1 0 0 1 .243-.307l-.993-.944 1.265.66c.093-.09.19-.174.292-.255L4.07 2.601l1.133.867c.106-.07.215-.136.327-.198l-.578-1.241.957 1.051c.114-.05.23-.098.35-.141l-.325-1.333.74 1.202a5.27 5.27 0 0 1 .364-.082l-.054-1.38.494 1.313a5.46 5.46 0 0 1 .369-.027L8.07 1.26l.223 1.372Zm-.232 1.304c1.131 0 2.135.427 2.777 1.088H5.284c.642-.66 1.645-1.088 2.777-1.088Zm5.763 1.088h-.053l.082-.013-.029.013Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
